<script setup>
import { useCustomizer } from '@store/customizer'
const $customizer = useCustomizer()
</script>

<template>
    <div class="fixed overflow-y-auto bg-white top-0 left-0 z-20 h-screen border-r border-[#EAECF0] px-4 py-5" :style="`width:${$customizer.sidebarWidth}`">
       <slot></slot>
    </div>
</template>